import palette, { colors } from './palette'
import sizes from './sizes'
import { zIndexes } from './zIndex'

const index = { palette, sizes, colors, zIndexes }

export default index
